import { CircularProgress, CircularProgressProps as MUICircularProgressProps } from '@mui/material';

interface CircularProgressProps extends Omit<MUICircularProgressProps, 'color'> {
  color?: string;
}

const Spinner = (args: CircularProgressProps) => {
  const {
    size = 22, color = 'currentColor', ...restArgs
  } = args;

  return (
    <CircularProgress
      // todo will be changed in nearest future
      sx={{
        '& .MuiCircularProgress-svg': {
          color,
        },
      }}
      size={size}
      {...restArgs}
    />
  );
};

export default Spinner;
